import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import Providers from "@/hoc/Providers.tsx";
import "../index.css";
import EnumContext from "@/hoc/EnumContext.tsx";
import type { AuthState } from "@/store/auth";
import { LicenseInfo } from "@mui/x-license";
import { Suspense } from "react";
import Loader from "@/components/Loader.tsx";
import { Notfound } from "@/views/errors/404.tsx";
import { ToastContainer } from "react-toastify";

 
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUIX);

export type RouterContext = {
  session: AuthState | null;
};

const RootLayout = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Providers>
        <EnumContext>
          <Outlet />
          <ToastContainer />
        </EnumContext>
      </Providers>
      <TanStackRouterDevtools />
    </Suspense>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: () => {
    return <Notfound />;
  },
});
